
import {TweenLite} from 'gsap';
import CustomEase from '../vendors/CustomEase';

const Utils = require('./Utils');
const DataUtils = require('../utils/data');


{TweenLite}
const CanvasMaskAnimationController = {
    setTranslate: function setTranslate() {
         const swiper = this;
        const slides = swiper.slides;
        const length = slides.length;
        for (let i = 0; i < length; i += 1) {
            const $slideEl = swiper.slides.eq(i);
            const progress = $slideEl[0].progress;
            const anims = CanvasMaskAnimationController.lazyGetAnimations($slideEl, swiper.params.CanvasMaskAnimationControl.targetEl, 'canvasMaskAnimations');
            const offset = $slideEl[0].swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) { tx -= swiper.translate; }
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }


            $slideEl.transform('translate3d(' + tx + 'px, ' + ty + 'px, 0px)');
            let a = Math.min(1, Math.max(-1, progress));
            if (!swiper.params.loop) {
                if (i === 0) a = Math.max(0, a);
                if (i === length - 1) a = Math.min(0, a);
            }
            if (a > -1 && a < 1 && a !== 0) {
                a = Math.sqrt(Math.abs(a)) * a / Math.abs(a);
                swiper.transition = true;
            }

            if (anims)
                anims.forEach(anim => {
                    if (!anim) return;
                    anim.progress = progress;
                    anim.maskShift = a;
                });
        }
    },
    setTransition: function setTransition(duration) {
         const swiper = this;
        const $wrapperEl = swiper.$wrapperEl;
        const slides = swiper.slides;
        const anims = CanvasMaskAnimationController.lazyGetAnimations($wrapperEl, swiper.params.CanvasMaskAnimationControl.targetEl, 'canvasMaskAnimations');
        const activeAnims = CanvasMaskAnimationController.lazyGetAnimations(slides.eq(swiper.activeIndex), swiper.params.CanvasMaskAnimationControl.targetEl, 'canvasMaskAnimations');


        const setDelay = (arr, delay) => {
            arr.forEach(anim => {if (!anim) return; anim.delay = delay;});
        }
        const setTransitionEnd = (arr, f) => {
            arr.forEach(anim => {if (!anim) return; anim.transitionEnd(f);});
        }
        const setEase = (arr, ease) => {
            arr.forEach(anim => {if (!anim) return; anim.ease = ease;});
        }

        anims.forEach(anim => {if (!anim) return; anim.duration = duration;});


        if (duration !== 0) {

            setDelay(anims, swiper.transition ? 0 : duration * 0.75);
            setEase(anims, CustomEase.create('custom', 'M0,0,C0.266,0.412,0.612,1,1,1'));
            // setEase(anims, CustomEase.create('custom', 'M0,0,C0.16,0.13,0.38,1,1,1'));
            // anims.css({transitionTimingFunction: 'cubic-bezier(0.16, 0.13, 0.38, 1)'});
            setDelay(activeAnims, 0);
            setEase(activeAnims, CustomEase.create('custom', 'M0,0,C0.434,0.004,0.79,0.698,1,1'));
            // setEase(activeAnims, CustomEase.create('custom', 'M0,0,C0.63,0,0.8,0.82,1,1'));
            // activeAnims.css({ transitionTimingFunction: 'cubic-bezier(0.63, 0, 0.8, 0.82)' });

            CanvasMaskAnimationController.setTranslate.call(swiper);
        } else {
            setDelay(anims, 0);
        }

        if (duration !== 0) {
            let eventTriggered = false;
            setTransitionEnd(anims, function () {

                if (eventTriggered) { return; }
                if (!swiper || swiper.destroyed) { return; }
                eventTriggered = true;
                swiper.animating = false;
                swiper.transition = false;
                const triggerEvents = ['webkitTransitionEnd', 'transitionend'];
                for (let i = 0; i < triggerEvents.length; i += 1) {
                    $wrapperEl.trigger(triggerEvents[i]);
                }
            });
            setTransitionEnd(activeAnims, function () { });
        }
    },
    lazyGetAnimations: function lazyGetAnimations($rootEl, el, name) {
        let anims = $rootEl.data(name);

        if (anims) return anims;

        const $targetEls = $rootEl.find(el);
        anims = [];

        $targetEls.each((i, el) => {
            anims.push(DataUtils.getData(el, 'canvasMaskAnimation'));
        });
        $rootEl.data(name, anims);
        return anims;
    }
};

const CanvasMaskAnimationControlEffect = {
    name: 'effect-CanvasMaskAnimationControl',
    params: {
        CanvasMaskAnimationControl: {
            targetEl: '[data-view]'
        }
    },
    create: function create() {
        const swiper = this;
        Utils.extend(swiper, {
            CanvasMaskAnimationControlEffect: {
                setTranslate: CanvasMaskAnimationController.setTranslate.bind(swiper),
                setTransition: CanvasMaskAnimationController.setTransition.bind(swiper)
            }
        });
    },
    on: {
        beforeInit: function beforeInit() {
            const swiper = this;
            if (swiper.params.effect !== 'CanvasMaskAnimationControl')
                return;

            swiper.classNames.push(swiper.params.containerModifierClass + 'CanvasMaskAnimationControl');
            const overwriteParams = {
                slidesPerView: 1,
                slidesPerColumn: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: true
            };
            Utils.extend(swiper.params, overwriteParams);
            Utils.extend(swiper.originalParams, overwriteParams);
        },
        init: function init() {
            const swiper = this;
            if (swiper.params.effect !== 'CanvasMaskAnimationControl')  return;
            swiper.CanvasMaskAnimationControlEffect.setTransition(0);
            swiper.CanvasMaskAnimationControlEffect.setTranslate();
        },
        setTranslate: function setTranslate() {
            const swiper = this;
            if (swiper.params.effect !== 'CanvasMaskAnimationControl')  return;
            swiper.CanvasMaskAnimationControlEffect.setTranslate();
        },
        setTransition: function setTransition(duration) {
            const swiper = this;
            if (swiper.params.effect !== 'CanvasMaskAnimationControl')  return;
            swiper.CanvasMaskAnimationControlEffect.setTransition(duration > 0 ? swiper.params.speed : 0);
        }
    }
};

module.exports = CanvasMaskAnimationControlEffect;



// WEBPACK FOOTER //
// ./js/swiperEffects/CanvasMaskAnimationControlEffect.js